/* global Office */

export class RecurrenceInfo {
  recurrenceType: string = "";
  interval: number = 1;
  daysOfWeek: string = "";
  dayOfMonth: number = -1;
  weekOfMonth: number = -1;
  monthOfYear: number = -1;
  recurrenceStart: string = "";
  recurrenceEnd: string = "";
  timeZone: string = "";
  timeZoneType: string = "Windows";

  constructor(initializer?: Office.Recurrence) {
    if (!initializer) return;

    // convert from Office format attributes to Archibus common recurrence format attributes
    this.setRecurrenceType(initializer.recurrenceType);
    if (initializer.recurrenceProperties) {
      this.interval = initializer.recurrenceProperties.interval;
      if (initializer.recurrenceProperties.dayOfMonth) this.dayOfMonth = initializer.recurrenceProperties.dayOfMonth;
      if (initializer.recurrenceProperties.month) {
        this.setMonthOfYear(initializer.recurrenceProperties.month);
      }
      if (initializer.recurrenceProperties.weekNumber) {
        this.setWeekOfMonth(initializer.recurrenceProperties.weekNumber);
      }
      if (initializer.recurrenceProperties.dayOfWeek) {
        this.daysOfWeek = initializer.recurrenceProperties.dayOfWeek;
      } else if (initializer.recurrenceProperties.days) {
        this.daysOfWeek = initializer.recurrenceProperties.days.join(",").toLowerCase();
      }
    }
    this.recurrenceStart = initializer.seriesTime.getStartDate();
    this.recurrenceEnd = initializer.seriesTime.getEndDate();
    if (initializer.recurrenceTimeZone) this.timeZone = initializer.recurrenceTimeZone.name;
  }

  private setMonthOfYear(month: string) {
    const MONTHS_OF_YEAR = [
      Office.MailboxEnums.Month.Jan,
      Office.MailboxEnums.Month.Feb,
      Office.MailboxEnums.Month.Mar,
      Office.MailboxEnums.Month.Apr,
      Office.MailboxEnums.Month.May,
      Office.MailboxEnums.Month.Jun,
      Office.MailboxEnums.Month.Jul,
      Office.MailboxEnums.Month.Aug,
      Office.MailboxEnums.Month.Sep,
      Office.MailboxEnums.Month.Oct,
      Office.MailboxEnums.Month.Nov,
      Office.MailboxEnums.Month.Dec,
    ];

    // monthOfYear starts at 1
    this.monthOfYear = MONTHS_OF_YEAR.findIndex((value) => month == value) + 1;
  }

  private setRecurrenceType(recurrenceType: string) {
    switch (recurrenceType) {
      case Office.MailboxEnums.RecurrenceType.Daily:
        this.recurrenceType = "day";
        break;
      case Office.MailboxEnums.RecurrenceType.Weekday:
        this.recurrenceType = "week";
        this.daysOfWeek = "mon,tue,wed,thu,fri";
        break;
      case Office.MailboxEnums.RecurrenceType.Weekly:
        this.recurrenceType = "week";
        break;
      case Office.MailboxEnums.RecurrenceType.Monthly:
        this.recurrenceType = "month";
        break;
      case Office.MailboxEnums.RecurrenceType.Yearly:
        this.recurrenceType = "year";
        break;
      default:
        this.recurrenceType = recurrenceType;
        break;
    }
  }

  private setWeekOfMonth(weekOfMonth: string) {
    const WEEKS_OF_MONTH = [
      Office.MailboxEnums.WeekNumber.First,
      Office.MailboxEnums.WeekNumber.Second,
      Office.MailboxEnums.WeekNumber.Third,
      Office.MailboxEnums.WeekNumber.Fourth,
      Office.MailboxEnums.WeekNumber.Last,
    ];
    // weekNumber starts at 1
    this.weekOfMonth = WEEKS_OF_MONTH.findIndex((value) => weekOfMonth == value) + 1;
  }

  toUrlParams(): string {
    let params = `&recurrenceType=${this.recurrenceType}&interval=${this.interval}`;
    if (this.daysOfWeek != "") {
      params += `&daysOfWeek=${this.daysOfWeek}`;
    }
    if (this.dayOfMonth != -1) {
      params += `&dayOfMonth=${this.dayOfMonth}`;
    }
    if (this.weekOfMonth != -1) {
      params += `&weekOfMonth=${this.weekOfMonth}`;
    }
    if (this.monthOfYear != -1) {
      params += `&monthOfYear=${this.monthOfYear}`;
    }
    if (this.recurrenceStart != null) {
      params += `&recurrenceStart=${this.recurrenceStart}`;
    }
    if (this.recurrenceEnd != null) {
      params += `&recurrenceEnd=${this.recurrenceEnd}`;
    }
    if (this.timeZone != "") {
      params += `&timeZone=${this.timeZone}`;
    }
    if (this.timeZoneType != "") {
      params += `&timeZoneType=${this.timeZoneType}`;
    }
    return params;
  }
}
